import { __extends } from "tslib";
import { deepMix } from '@antv/util';
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';

var Sunburst =
/** @class */
function (_super) {
  __extends(Sunburst, _super);

  function Sunburst() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型 */


    _this.type = 'sunburst';
    return _this;
  }
  /**
   * 获取旭日图默认配置
   */


  Sunburst.prototype.getDefaultOptions = function () {
    return deepMix({}, _super.prototype.getDefaultOptions.call(this), {
      type: 'partition',
      innerRadius: 0,
      seriesField: 'value',
      tooltip: {
        showTitle: false,
        showMarkers: false
      }
    });
  };
  /**
   * 获取旭日图的适配器
   */


  Sunburst.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };

  return Sunburst;
}(Plot);

export { Sunburst };